import { rawTimeZones, RawTimeZone } from '@vvo/tzdb'
import { isValid } from 'date-fns'

import { Interval } from '@/gql/graphql'

export const parseDate = (dateStr: string | null | undefined) => {
  if (!dateStr) {
    return null
  }

  const date = new Date(dateStr)

  const yyyy = date.getFullYear().toString()
  const MM = (date.getMonth() + 1).toString().padStart(2, '0')
  const dd = date.getDate().toString().padStart(2, '0')
  return new Date(`${yyyy}-${MM}-${dd}T00:00:00.000Z`)
}

export const getOffsetFromTimeZoneName = (
  timeZoneName: RawTimeZone['name'],
) => {
  const timeZone = rawTimeZones.find(timeZone => timeZone.name === timeZoneName)

  if (!timeZone) {
    return 0
  }

  return (timeZone.rawOffsetInMinutes || 0) / 60
}

export const convertNumToTime = (number: number) => {
  const sign = number >= 0 ? 1 : -1

  number = number * sign

  const hour = Math.floor(number)
  let decpart = number - hour

  const min = 1 / 60
  decpart = min * Math.round(decpart / min)

  const minute = Math.floor(decpart * 60)
    .toString()
    .padStart(2, '0')

  return `${sign === 1 ? '' : '-'}${hour}:${minute}`
}

export const addOffsetToTimeString = (timeString: string, offset: number) => {
  const offsetCharacter = timeString.includes('+') ? '+' : '-'

  const timeStringWithoutTimeZone = timeString?.split(offsetCharacter)[0]

  const offsetTimeString = convertNumToTime(offset)

  const offsetString = `${
    offset >= 0 ? offsetCharacter : ''
  }${offsetTimeString.padStart(2, '0')}`

  return timeStringWithoutTimeZone + offsetString
}

export const isMidnight = (date: Date | string): boolean => {
  let isoString

  if (typeof date === 'string') {
    isoString = date
  } else if (isValid(date)) {
    isoString = date.toISOString()
  }

  return isoString?.includes('T00:00:00') ?? false
}

export const sumIntervals = (intervals: Interval[]): Interval => {
  const summedElapsedTimes = intervals.reduce(
    (acc, interval) => {
      return {
        hours:
          (acc.hours || 0) +
          (interval?.hours ?? 0) +
          (interval?.days ?? 0) * 24,
        minutes: (acc.minutes || 0) + (interval?.minutes ?? 0),
      }
    },
    { hours: 0, minutes: 0 },
  )

  return {
    hours:
      (summedElapsedTimes.hours || 0) +
      Math.floor((summedElapsedTimes.minutes || 0) / 60),
    minutes: (summedElapsedTimes.minutes || 0) % 60,
  }
}

export const sumIntervalsToMinutes = (intervals: Interval[]): number => {
  const summedElapsedTimes = sumIntervals(intervals)

  return (
    (summedElapsedTimes.hours || 0) * 60 + (summedElapsedTimes.minutes || 0)
  )
}
